import { render, staticRenderFns } from "./HotelsManage.vue?vue&type=template&id=31e5ac01&scoped=true"
import script from "./HotelsManage.vue?vue&type=script&lang=js"
export * from "./HotelsManage.vue?vue&type=script&lang=js"
import style0 from "./HotelsManage.vue?vue&type=style&index=0&id=31e5ac01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5ac01",
  null
  
)

export default component.exports